import React from "react";

export default function ServiceSelect(props) {
  return (
    <div className="input-rapper">
      <p className="label">{props.label}</p>
      <div className="select-tip-rapper">
        <select
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          required={props.required}
          autoFocus={props.autoFocus}
        >
          {props.placeholder && (
            <option value="" disabled>
              {props.placeholder}
            </option>
          )}
          {props.children}
        </select>
        <span className="tip"></span>
      </div>
    </div>
  );
}